import { render, staticRenderFns } from "./color_list.vue?vue&type=template&id=5e450513&scoped=true&"
import script from "./color_list.vue?vue&type=script&lang=js&"
export * from "./color_list.vue?vue&type=script&lang=js&"
import style0 from "./color_list.vue?vue&type=style&index=0&id=5e450513&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e450513",
  null
  
)

export default component.exports